export const config = {
  ai: {
    enabled: process.env.PUBLIC_AI_ENABLED === 'true',
  },
  api: {
    baseUrl: process.env.PUBLIC_API_BASE_URL as string,
  },
  auth0: {
    audience: process.env.PUBLIC_AUTH0_AUDIENCE as string,
    clientId: process.env.PUBLIC_AUTH0_CLIENT_ID as string,
    domain: process.env.PUBLIC_AUTH0_DOMAIN as string,
  },
  app: {
    baseUrl: process.env.PUBLIC_BASE_URL as string,
    brandName: 'Azymmetric',
    runtimeEnvironment: process.env.PUBLIC_RUNTIME_ENVIRONMENT as string,
  },
  ...(process.env.PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID && {
    googleAnalytics: {
      measurementId: process.env.PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID,
    },
  }),
  ...(process.env.PUBLIC_POSTHOG_API_KEY && {
    posthog: {
      apiKey: process.env.PUBLIC_POSTHOG_API_KEY,
    },
  }),
  ...(process.env.PUBLIC_SENTRY_DSN && {
    sentry: {
      dsn: process.env.PUBLIC_SENTRY_DSN,
    },
  }),
};
